import type { ProLayoutProps } from '@ant-design/pro-components'
import type { MenuProps } from 'antd'
import { Avatar, Dropdown } from 'antd'
import { logout } from '../src/pages/user/login/service'
import { clearAuth, getUserInfo } from '../src/utils/token'

const redirectToLogin = () => {
  const { pathname, search } = window.location
  const searchParams = new URLSearchParams({
    redirect: pathname + search,
  })

  window.location.href = `/user/login?${searchParams.toString()}`
}

const handleLogout = async () => {
  try {
    await logout()
  } catch (error) {
  } finally {
    clearAuth()
    redirectToLogin()
  }
}

const userMenuItems: MenuProps['items'] = [
  {
    key: 'logout',
    label: '退出登录',
  },
]

const UserFooter = ({ collapsed }: { collapsed?: boolean }) => {
  const userInfo = getUserInfo()
  const displayName = userInfo?.realName || userInfo?.username || '系统用户'
  const roleName = userInfo?.roleName || '管理员'
  const avatarText = displayName.slice(0, 1).toUpperCase()

  return (
    <Dropdown
      placement="topRight"
      trigger={['click']}
      menu={{
        items: userMenuItems,
        onClick: ({ key }) => {
          if (key === 'logout') {
            handleLogout()
          }
        },
      }}
    >
      <div
        style={{
          margin: collapsed ? '8px' : '12px',
          padding: collapsed ? '8px 0' : '12px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: collapsed ? 'center' : 'flex-start',
          gap: 12,
          background: 'rgba(255,255,255,0.08)',
          borderRadius: 14,
          cursor: 'pointer',
          transition: 'background 0.2s ease',
        }}
      >
        <Avatar
          size={32}
          src={userInfo?.avatar}
          style={{
            backgroundColor: '#FF6B35',
            color: '#fff',
            fontWeight: 600,
            flexShrink: 0,
          }}
        >
          {avatarText}
        </Avatar>
        {!collapsed && (
          <div style={{ minWidth: 0, lineHeight: 1.25 }}>
            <div
              style={{
                color: '#fff',
                fontSize: 15,
                fontWeight: 600,
              }}
            >
              {displayName}
            </div>
            <div
              style={{
                color: 'rgba(255,255,255,0.65)',
                fontSize: 12,
                marginTop: 2,
              }}
            >
              {roleName}
            </div>
          </div>
        )}
      </div>
    </Dropdown>
  )
}

const Settings: ProLayoutProps & {
  pwa?: boolean;
} = {
  navTheme: 'light',
  colorPrimary: '#FF6B35',
  layout: 'side',
  siderWidth: 200,
  contentWidth: 'Fluid',
  fixedHeader: false,
  fixSiderbar: true,
  colorWeak: false,
  title: '徐州恒顺代理商补货管理系统',
  pwa: true,
  iconfontUrl: '',
  menuHeaderRender: (_logo, _title, props) => {
    if (props?.collapsed) {
      return (
        <div className="!h-10 !w-10 flex items-center justify-center bg-[#FF6B35] text-white rounded-xl text-[20px]">
          恒
        </div>
      )
    }
    return (
      <div className="flex items-center">
        <div className="!h-10 !w-10 flex items-center justify-center bg-[#FF6B35] text-white rounded-xl text-[20px]">
          恒
        </div>
        <div className="!ml-2">
          <div className="text-[16px]">恒顺代理商</div>
          <div className="text-[12px]">补货管理系统</div>
        </div>
      </div>
    )
  },
  menuFooterRender: (props) => {
    return <UserFooter collapsed={props?.collapsed} />
  },
  token: {
    colorPrimary: '#FF6B35',
    sider: {
      colorMenuBackground: '#001529',
      colorTextMenu: 'rgba(255,255,255,0.65)',
      colorTextMenuSelected: '#fff',
      colorBgMenuItemSelected: '#FF6B35',
      colorBgMenuItemHover: '#001529',
      colorTextMenuItemHover: 'rgba(255,255,255,0.65)',
      colorTextMenuTitle: '#FFF',
    },
  },
  splitMenus: false,
  siderMenuType: 'sub',
  footerRender: false,
  contentStyle: {
    padding: 0,
  },
}

export default Settings
